import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanCommissionUser } from '../add-commission/add-commission.component';

@Component({
    selector: 'app-edit-commission',
    templateUrl: './edit-commission.component.html',
    styleUrls: ['./edit-commission.component.scss'],
    standalone: false
})
export class EditCommissionComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  @Input() amount: number;
  @Input() assignee: string;
  @Input() loanId: number;
  @Input() commissionId: number;
  @Output() passEntry = new EventEmitter<any>();

  userList: string[] = [];

  loanCommissionUserList: LoanCommissionUser[] = [];

  ngOnInit(): void {
    this.getAllUser();
  }

  async getAllUser() {
    const xhttp = this.restapi.getRequest(this.constructApi.getLoanCommissionUsers(this.loanId))
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        const json = JSON.parse((xhttp.responseText))
        const userArray = json.users;
        userArray.forEach(json => {
          const user = json.username;

          const index = this.loanCommissionUserList.findIndex(commissionUser => commissionUser.companyCode == json.companyCode)

          if (index != -1)
            this.loanCommissionUserList[index].usernameList.push(user);
          else {
            const loanCommissionUser = { companyCode: json.companyCode, usernameList: [json.username] };
            this.loanCommissionUserList.push(loanCommissionUser);
          }
        });
      }
    };
  }

  updateCommission() {
    const data = {
      "amount": this.amount,
      "assignee": this.assignee,
      "dateCreated": new Date().toISOString(),
      "id": Number(this.commissionId)
    };

    const xhr = this.restapi.patchRequest(this.constructApi.getEditCommission(Number(this.loanId)), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        //if success emit
        this.passEntry.emit();
        this.reset();
        this.sharedService.openAlert("Successfully updated commission", ALERT_TYPE.SUCCESS)
      }
    }
  }

  confirmBeforeUpdate() {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to update commission = RM " + this.amount + " to " + this.assignee + "?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.updateCommission();
    });

    return proceed;
  }

  checkFieldNull() {
    const amountNull = this.amount == undefined;
    const amountValid = isNaN(+this.amount);
    const assigneeNull = this.assignee == undefined;

    return amountNull || amountValid || assigneeNull;
  }

  reset() {
    this.activeModal.close();
  }
}
